import {
  getMonth,
  getYear,
  months,
} from '@/components/formBuilder/formFields/DateField/components/dateFieldHelpers';
import { Box, Flex, MenuItem, MenuList } from '@chakra-ui/react';
import { ChevronLeft, ChevronRight } from '@kula-ai/icons-core';
import { KMenuButton } from '@/ui-library/components';

export const CustomDateNavHeader = (props) => {
  const {
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    changeMonth,
  } = props;

  const currentMonth = getMonth(date);
  const currentYear = getYear(date);

  const handleMonthSelect = (monthIndex) => {
    changeMonth(monthIndex);
  };

  return (
    <Flex justifyContent="space-between" w="100%" alignItems="center" pl="10px">
      <KMenuButton
        variant="primary"
        triggerContent={`${months[currentMonth]} ${currentYear}`}
        dividerProps={{ display: 'none' }}
        bg="transparent"
        color="secondary-900"
        size="sm-medium"
        iconProps={{ mr: '2px' }}
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        menuContent={
          <MenuList border="none" boxShadow="none" p={0}>
            {months.map((month, index) => (
              <MenuItem
                key={month}
                onClick={() => handleMonthSelect(index)}
                bg={currentMonth === index ? 'secondary-25' : 'white'}
                _hover={{ bg: 'secondary-25' }}
                color="secondary-700"
              >
                {month}
              </MenuItem>
            ))}
          </MenuList>
        }
      />

      <Flex
        borderWidth="1px"
        borderRadius="md"
        overflow="hidden"
        borderColor="border-color"
      >
        <Box
          p="2"
          onClick={!prevMonthButtonDisabled ? decreaseMonth : undefined}
          cursor={prevMonthButtonDisabled ? 'not-allowed' : 'pointer'}
          opacity={prevMonthButtonDisabled ? 0.5 : 1}
          color="primary-600"
        >
          <ChevronLeft size={20} />
        </Box>
        <Box
          borderLeftWidth="1px"
          borderColor="border-color"
          p="2"
          onClick={!nextMonthButtonDisabled ? increaseMonth : undefined}
          cursor={nextMonthButtonDisabled ? 'not-allowed' : 'pointer'}
          opacity={nextMonthButtonDisabled ? 0.5 : 1}
          color="primary-600"
        >
          <ChevronRight size={20} />
        </Box>
      </Flex>
    </Flex>
  );
};
